import _ from "lodash";
import ListPageUtils from "./ListPageUtils";
import Tracking from "../uidispatcherapi/Tracking";
import { StructuredTrackingData } from "../datatypes/Tracking";
import { generateUuid } from "./util";

const sanitizeListType = (listType: string) => {
    if (listType === ListPageUtils.personalListOld) {
        return ListPageUtils.personalList;
    }
    if (listType === ListPageUtils.storeList) {
        return "METRO";
    }
    return listType;
};

const sanitizeSearchString = (string: string) => {
    return _.trim((string || "").toLowerCase().replace(/\s\s+/g, " "));
};

const getQuantitiyTypeOfListType = (listType: string) => {
    return listType === ListPageUtils.savedCartList || listType === ListPageUtils.reorderList
        ? "with quantities"
        : "without quantities";
};

const trackUIError = (
    component: string,
    message: string,
    exception?: any | null | undefined,
    moreData?: Object | null | undefined
) => {
    if (!exception) {
        Tracking.trackError("inspiration", "ui", component, message);
        console.warn("Error in component " + component + ": " + message);
    } else {
        Tracking.trackError("inspiration", "ui", component, message, {
            exception: exception.stack ? exception.stack : JSON.stringify(exception),
            moreData: JSON.stringify(moreData),
            reqCti: exception.callTreeId
        });
        console.warn("Error in component " + component + ": " + message, exception);
    }
};

const trackStructuredAction = (
    eventType: string,
    structuredData: StructuredTrackingData,
    hiddenData?: Object | null | undefined
) => {
    const tags = _.merge({}, { eventId: generateUuid() }, structuredData.tags);
    const structuredDataWithEventId: StructuredTrackingData = structuredData.metric
        ? { metric: structuredData.metric, tags: tags }
        : { tags: tags };
    Tracking.trackStructuredEvent("inspiration", "ui", eventType, structuredDataWithEventId, hiddenData);
};

const trackStructuredEvent = (
    eventType: string,
    structuredData: StructuredTrackingData,
    hiddenData?: Object | null | undefined
) => {
    Tracking.trackStructuredEvent("inspiration", "ui", eventType, structuredData, hiddenData);
};

const trackForGtmOnly = (
    eventType: string,
    structuredData: StructuredTrackingData,
    hiddenData: Object | null | undefined
) => {
    Tracking.trackForGtmOnly("inspiration", "ui", eventType, structuredData, hiddenData);
};

const exported = {
    sanitizeListType,
    sanitizeSearchString,
    getQuantitiyTypeOfListType,
    trackStructuredAction,
    trackUIError,
    trackStructuredEvent,
    trackForGtmOnly
};

export default exported;
export {
    sanitizeListType,
    sanitizeSearchString,
    getQuantitiyTypeOfListType,
    trackStructuredAction,
    trackUIError,
    trackStructuredEvent,
    trackForGtmOnly
};
